import type { OverlaySnapshot } from './desktop'
import type { User, VoiceState } from '@/types/api'

interface Input {
  connection: { status: OverlaySnapshot['status'] } | null
  channel: string
  self: User | null
  remote: Record<string, true>
  speaking: Record<string, boolean>
  selfMute: boolean
  selfDeaf: boolean
  live?: Record<string, string>
  selfSharing?: boolean
  states: Record<string, VoiceState>
  member: (id: string) => { user: User; nick: string | null } | undefined
  user: (id: string) => User | undefined
  avatar: (id: string) => string | undefined
}

/** Membership comes from the actual media room, rather than stale gateway presence. */
export function voiceOverlaySnapshot(input: Input): OverlaySnapshot | null {
  if (!input.connection || !input.self) return null
  const selfId = input.self.id
  return {
    channel: input.channel,
    status: input.connection.status,
    participants: [selfId, ...Object.keys(input.remote).filter((id) => id !== selfId)].slice(0, 100).map((id) => {
      const self = id === selfId
      const state = input.states[id]
      const member = input.member(id)
      const user = self ? input.self : member?.user ?? input.user(id)
      const deafened = Boolean(state?.afk) || (self ? input.selfDeaf || Boolean(state?.deaf) : Boolean(state?.self_deaf || state?.deaf))
      const muted = deafened || (self ? input.selfMute || Boolean(state?.mute || state?.suppress) : Boolean(state?.self_mute || state?.mute || state?.suppress))
      const tag = user?.primary_guild?.identity_enabled ? user.primary_guild : null
      return { tag: tag?.tag ?? null, tagColor: tag?.color ?? null, streaming: Boolean((self && input.selfSharing) || (input.live && Object.hasOwn(input.live, id))), id, name: member?.nick ?? user?.global_name ?? user?.username ?? 'Участник', avatar: input.avatar(id) ?? null, self, muted, deafened, speaking: input.connection?.status === 'connected' && input.speaking[id] === true && !muted }
    }),
  }
}
